import { routes } from "@/constants/routes";
import { Redirect } from "expo-router";

export default function TenantAnimalEditRedirect() {
  return <Redirect href={routes.myAnimals} />;
}
